module.exports = __webpack_public_path__ + "img/beshak.c338f308.png";